import React from 'react'
import { withRouteData, Head } from 'react-static'
import Markdown from 'react-markdown'

import ColumnList from '../components/ColumnList'

const Activities = ({ page }) => [
  <Head key="activities-head">
    <title>{page.data.title}</title>
    <meta name="description" content={`${page.data.description}`} />
    <style>{`
      body {
        background-image: url('${page.data.backgroundImage}');
        background-size: cover;
        background-attachment: fixed;
      }
    `}
    </style>
  </Head>,
  <div key="activities-content" className="page-content">
    <h2>Activities</h2>
    <div className="column-container">
      <ColumnList
        title={page.data.left}
        items={page.data.leftItems.map(item => item.item)}
      />
      <ColumnList
        title={page.data.right}
        items={page.data.rightItems.map(item => item.item)}
      />
    </div>
    <Markdown source={page.content} escapeHtml={false} />
  </div>,
]

const activitiesWithRouteData = withRouteData(Activities)

export default activitiesWithRouteData



// WEBPACK FOOTER //
// /opt/build/repo/src/containers/Activities.js